var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickWhiteSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.79952 6.30001L1.69952 4.20001L0.999522 4.90001L3.79952 7.70001L9.79952 1.70001L9.09952 1.00001L3.79952 6.30001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79952 6.30001L9.09952 1.00001L9.79952 1.70001L3.79952 7.70001L0.999522 4.90001L1.69952 4.20001L3.79952 6.30001ZM3.79952 5.81514L9.09952 0.515137L10.2844 1.70001L3.79952 8.18488L0.514648 4.90001L1.69952 3.71514L3.79952 5.81514Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickWhiteSmall);
export default __webpack_public_path__ + "static/media/tickWhiteSmall.a54b0654ba6f186bd75f439b9dd61f8e.svg";
export { ForwardRef as ReactComponent };